<template>
  <div>
    <div style="margin-bottom: -30px">
      <img
        :src="getDynamicImageSrc('kungarna', '-340px.jpg', '-821px.jpg')"
        :style="getDynamicImageStyle('340px', '175px', '821px', '424px')"
        alt="Två unga kungar som skålar långhylsa Kung"
      >
    </div>
    <div
      class="content"
      style="margin-bottom: 10px"
    >
      <div
        class="header pure-g"
        style="padding-left: 10%; padding-bottom: 7px"
      >
        <div
          class="pure-u-8-24 logo-header-container"
        >
          <router-link to="/">
            <img
              src="../assets/logo-header.png"
              class="logo-header"
              alt="APKollens logga, en tecknad orange apa som dricker öl"
            >
          </router-link>
        </div>
        <div
          class="pure-u-16-24"
          style="text-align: left; margin-top: auto; margin-left: auto;"
        >
          <!-- Style overridden to fix gap -->
          <h1 class="page-header">
            APKollen.se
          </h1>
          <h2 class="page-subheader">
            <i>Jämför snabbt och enkelt hela Bordershoppens sortiment!</i>
          </h2>
        </div>
      </div>
      <div
        class="content"
        style="margin-top: .5em; margin-bottom: -1em"
      >
        <p>
          Nedan hittar du en uppdaterad topplista av BorderShops sortiment baserat på APK (Alkohol Per Krona). Använd reglagen för att förfina din sökning, eller läs mer i sidomenyn. Hemsidan uppdateras regelbundet, så titta förbi då och då för att inte missa ett apkap!
        </p>
        <p>
          Nyfiken på andra projekt? Kolla in <a
            href="https://github.com/ginger51011"
            target="blank"
            style="color: darkorange;"
          >min GitHub</a>!
        </p>
      </div>
    </div>
    <ApkApp />
  </div>
</template>

<script>

// We import apkApp here, then export that it is needed
import ApkApp from './ApkApp.vue'

export default {
    name: "Home",
    // metaInfo provided by Home component
    components: {
        ApkApp,
    },
    methods: {
        getDynamicImageSrc: function (imageName, mobileEnding, normalEnding) {
        let imageEnding = ""
        if (window.screen.width < 450) {
          imageEnding = mobileEnding;
        } else {
          imageEnding = normalEnding;
        }
        return require("@/assets/" + imageName + imageEnding);
      },
      // Prevents large Cumulative Layout Shift
      getDynamicImageStyle: function (mobileWidth, mobileHeight, normalWidth, normalHeight) {
        let style = "border-radius: 15px;";

          if (window.screen.width < 450) {
            return style + `width: ${mobileWidth}; height: ${mobileHeight};`;
          } else {
            return style + `width: ${normalWidth}; height: ${normalHeight};`;
          }
      }
    }
}
</script>
